import React, { Component } from 'react';
import * as $ from 'jquery';
import spinner from '../../images/loading-spinner.gif';
import { Document, Page } from 'react-pdf/dist/entry.webpack';
import { translate } from 'react-i18next';

class Invoice extends Component {

  constructor(props) {
    super(props);
    this.state = this.getInitState();
  }

  componentDidMount() {
    const documentWidth = $('.document').width();

    if (documentWidth < this.state.pageWidth) {
      this.setState({ pageWidth: documentWidth });
    }
    
    $('.document-wrapper').scroll(this.updatePageNumber);
  }

  componentWillReceiveProps() {
    this.setState({ isLoading: true });
  }

  componentWillUnmount() {
    $(window).off("scroll", this.updatePageNumber);
  }

  getInitState = () => {
    return({
      isLoading: true,
      numPages: 1,
      pageNumber: 1,
      pageWidth: 684,
      scale: 1.0
    });
  }

  handleDocumentError = () => {
    this.setState({ isLoading: false });
  }

  handleDocumentLoad = ({ numPages }) => {
    this.setState({
      isLoading: false,
      numPages
    });
  }

  handleNextClick = () => {
    let pageNumber = this.state.pageNumber;
    if (pageNumber < this.state.numPages) {
      this.setState({ pageNumber: pageNumber += 1 });
      this.scrollToPage(pageNumber);
    }
  }

  handlePreviousClick = () => {
    let pageNumber = this.state.pageNumber;
    if (pageNumber > 1) {
      this.setState({ pageNumber: pageNumber -= 1 });
      this.scrollToPage(pageNumber);
    }
  }

  handleZoomInClick = () => {
    let scale = this.state.scale;
    if (scale < 3.0) {
      this.setState({ scale: scale += 0.2 });
    }
  }

  handleZoomOutClick = () => {
    let scale = this.state.scale;
    if (scale > 0.5) {
      this.setState({ scale: scale -= 0.2 });
    }
  }

  scrollToPage(pageNumber) {
    $('#'+pageNumber)[0].scrollIntoView();
  }

  updatePageNumber = () => {
    for (let i = this.state.numPages; i >= 1; i--) {
      if ($('.document-wrapper').scrollTop() >= $('#'+i).position().top) {
        this.setState({ pageNumber: i });
        break;
      }
    }
  }

  renderPage = (pageNumber) => {
    return(
      <div id={pageNumber} key={pageNumber}>
        <Page
          width={this.state.pageWidth * this.state.scale}
          className="document-page"
          pageNumber={pageNumber} />
      </div>
    );
  }

  render() {
    const { t } = this.props;
    let pages = [];

    for (let i = 1; i <= this.state.numPages; i++) {
      pages.push(this.renderPage(i));
    }

    return(
      <div className="invoice-panel panel panel-default">
        <div className="panel-heading">
          <div className="btn-group pull-left">
            <button
              className="btn btn-default btn-sm"
              onClick={this.handleZoomInClick}
              type="button">
              <i className="glyphicon glyphicon-zoom-in" />
            </button>
            <button
              className="btn btn-default btn-sm"
              onClick={this.handleZoomOutClick}
              type="button">
              <i className="glyphicon glyphicon-zoom-out" />
            </button>
          </div>
          <button
            className="btn btn-default btn-sm"
            onClick={this.handlePreviousClick}
            type="button">
            <i className="glyphicon glyphicon-chevron-left" />
          </button>
          <span className="hidden-xs">
            <h4 className="panel-title">
              {this.state.pageNumber + " / " + this.state.numPages}
            </h4>
          </span>
          <button
            className="btn btn-default btn-sm"
            onClick={this.handleNextClick}
            type="button">
            <i className="glyphicon glyphicon-chevron-right" />
          </button>
          <div className="btn-group pull-right">
            <a className="btn btn-default btn-sm" href={this.props.pdf} rel="noopener noreferrer" target="_blank">
              PDF&nbsp;<i className="fa fa-download" />
            </a>
            <a className="btn btn-default btn-sm" href={this.props.xml} rel="noopener noreferrer" target="_blank">
              XML&nbsp;<i className="fa fa-download" />
            </a>
          </div>
        </div>
        <div className="panel-body text-center">
          <img
            width="45px"
            height="45px"
            alt={t('dashboard.reservations.img_spinner')}
            className={this.state.isLoading ? "" : "hidden"}
            src={spinner} />
          <div className="document-wrapper">
            <Document
              className="document"
              file={this.props.pdf}
              loading=""
              noData=""
              onLoadSuccess={this.handleDocumentLoad}
              onLoadError={this.handleDocumentError}>
              {pages}
            </Document>
          </div>
        </div>
      </div>
    );
  }
}

export default translate('common')(Invoice);



// WEBPACK FOOTER //
// ./src/dashboard/invoices/Invoice.js